import Lottie from "react-lottie";
import { Button, UnderlinedSectionHeader, DottedDivider } from "@components";
import * as lottie from "@assets/lottie";
import { routesFlat } from "@routes";
import * as styles from "./styles";

const s3Bucket =
    "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/landing/";

export default function Products() {
    // Note: Can't move to constants because need link route reference.
    const solutions = [
        {
            title: "Quantify global change",
            subheader:
                "Track collective progress on GHG reductions at any scale globally with precision and confidence.",
            bgImg: `${s3Bucket}global.png`,
            link: routesFlat.globalAssessment,
            animationData: lottie.SolutionEarth,
            img: "https://ctrees-website.s3.us-west-2.amazonaws.com/webv3/solutions/beats/global.png",
        },
        {
            title: "Plan jurisdictional actions",
            subheader:
                "Monitor and verify performance of climate mitigation and credited actions at national and sub-national levels.",
            bgImg: `${s3Bucket}country-and-state.png`,
            link: routesFlat.countryState,
            animationData: lottie.SolutionCali,
            img: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/hero/country-and-state.png",
        },
        {
            title: "Scale carbon investments",
            subheader:
                "Access open, science-based data to reduce risk and strengthen the integrity of nature-based carbon credits.",
            bgImg: `${s3Bucket}carbon-markets.png`,
            link: routesFlat.carbonMarkets,
            animationData: lottie.SolutionTree,
            img: "https://ctrees-website.s3.amazonaws.com/webv3/solutions/hero/carbon-markets.png",
            imgClass: "object-left",
        },
    ];
    return (
        <>
            <UnderlinedSectionHeader className="mt-20 md:mt-0">
                Solutions
            </UnderlinedSectionHeader>
            <div className={styles.parentContainer}>
                {solutions.map((solution) => {
                    const lottieOptions = {
                        ...lottie.defaultOptions,
                        animationData: solution.animationData,
                    };

                    return (
                        <div className={styles.solutionContainer}>
                            <div className={styles.title}>{solution.title}</div>
                            <div className={styles.lottie}>
                                <img
                                    className={styles.bgImg}
                                    src={solution.bgImg}
                                />
                                <Lottie
                                    options={lottieOptions}
                                    height={"auto"}
                                    width={300}
                                />
                            </div>

                            <div className="my-4 text-center md:w-[340px] md:text-lg">
                                {solution.subheader}
                            </div>
                            <Button className="px-10" to={solution.link}>
                                Learn More
                            </Button>
                            <DottedDivider className="my-10 w-full lg:hidden" />
                        </div>
                    );
                })}
            </div>
        </>
    );
}
